module.exports = __webpack_public_path__ + "img/no_cost_challenge.18094489.jpg";